import React, { useEffect, useState } from 'react';
import { apiGet } from '../../api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const UserStats = () => {
  const { username } = useParams();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const res = await apiGet(`/api/admin/user/${username}/stats`);
        setStats(res.data.data);
      } catch (err) {
        toast.error('Failed to fetch user stats');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [username]);

  return (
    <div>
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">User <span className="text-gradient-ginox">Stats</span></h1>
      <p className="text-sm text-muted-foreground mb-6">
        Stats for <span className="font-mono text-foreground">#{username}</span>
      </p>

      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-ginox-green" />
        </div>
      ) : !stats ? (
        <div className="rounded-lg border border-border/70 bg-card p-10 text-center text-sm text-muted-foreground">
          No stats found
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {Object.entries(stats).map(([key, value]) => (
            <div key={key} className="rounded-lg border border-border/70 bg-card p-5">
              <p className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1 capitalize">
                {key.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').trim()}
              </p>
              <p className="font-mono text-xl text-foreground">{String(value)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserStats;
